import {TimelineTimeAxisScaleType} from 'vis-timeline/esnext';
import {ScaleType} from '@/views/timeline/services/scale.type';

const MECHANICS_SCALE_SETTINGS_SIMPLIFIED: Map<TimelineTimeAxisScaleType, ScaleType> = new Map();
MECHANICS_SCALE_SETTINGS_SIMPLIFIED.set('day', {
    columnWidth: 72,
    columnCount: 150,
    name: 'Tagesansicht',
    iconName: 'calendar-today',
    buttonColor: 'green'
});

export {MECHANICS_SCALE_SETTINGS_SIMPLIFIED};
